import { connect, useDispatch } from "react-redux";

import DepartmentResourceEdit from "./departmentResourceEdit";
import { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getDepartmentResources,
  getDepartmentResource,
  deleteDepartmentResource,
} from "../../../../../action/masters/departmentResourceActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  IDepartmentResourceIndex,
  IDepartmentResources,
} from "../../../../../models/master/departmentResources";
import { setDepartmentResources } from "../../../../../store/slices/master/departmentResource";
import DepartmentResourceCreate from "./departmentResourceCreate";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";

const DepartmentResourceIndex = (props: IDepartmentResourceIndex) => {
  const {
    getDepartmentResources,
    departmentResources,
    getDepartmentResource,
    departmentResource,
    deleteDepartmentResource,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getDepartmentResource(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteDepartmentResource(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllDepartmentResources();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllDepartmentResources = async () => {
    setIsLoading(true);
    try {
      await getDepartmentResources();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllDepartmentResources();
    return () => {
      dispatch(setDepartmentResources([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Department Resources</h2>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={handleCreateOpen}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : departmentResources && departmentResources.length > 0 ? (
            departmentResources.map(
              (departmentResource: IDepartmentResources) => {
                return (
                  <li
                    className="admin-card"
                    style={{
                      pointerEvents: !departmentResource.isActive
                        ? "none"
                        : "auto",
                      opacity: !departmentResource.isActive ? 0.5 : 1,
                    }}
                  >
                    <div className="top">
                      <div className="btn-flex">
                        <button
                          className="btn-edit"
                          onClick={() => editItem(departmentResource.id ?? 0)}
                        >
                          <img src="/assets/images/icon/edit-wh.svg" alt="" />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => deleteItem(departmentResource.id ?? 0)}
                        >
                          <img src="/assets/images/icon/trash-wh.svg" alt="" />
                        </button>
                      </div>
                    </div>
                    <a href={departmentResource.url} target="_blank">
                      <div className="btm">
                        <div className="img">
                          <img
                            src={
                              departmentResource.image
                                ? baseURL + departmentResource.image
                                : ""
                            }
                          />
                        </div>
                        <h2>{departmentResource.name} </h2>
                      </div>
                    </a>
                  </li>
                );
              }
            )
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <DepartmentResourceCreate
          setShowCreate={handleCreateClose}
          getAllDepartmentResources={() => getAllDepartmentResources()}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <DepartmentResourceEdit
            setShowEdit={handleEditClose}
            getAllDepartmentResources={() => getAllDepartmentResources()}
            departmentResource={departmentResource}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getDepartmentResources: (
    pageBlockId?: number,
    noOfItems?: number,
    userType?: number
  ) => getDepartmentResources(pageBlockId, noOfItems, userType),
  getDepartmentResource: (id: number) => getDepartmentResource(id),
  deleteDepartmentResource: (id: number, callBack: Function) =>
    deleteDepartmentResource(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    departmentResources: state.departmentResource.departmentResources,
    departmentResource: state.departmentResource.departmentResource,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DepartmentResourceIndex);
